import { NotificationPreferences } from 'notification-kit/client/index.js';

export function NotificationsPage() {
  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Notifications</h1>
          <p className="page-meta">La cloche en haut à droite liste les notifications reçues</p>
        </div>
      </div>
      <div className="card">
        <div className="card-header">
          <span className="card-title">Préférences</span>
        </div>
        <div className="p-16">
          <NotificationPreferences />
        </div>
      </div>
    </div>
  );
}
